<template>
  <div class="form-group">
    <label>
      <BaseIcon :type="labelIcon" v-if="labelIcon" />
      <span>{{ label }}</span>
      <slot name="link"></slot>
    </label>
    <div class="form-group__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@base/BaseIcon'
export default {
  name: 'ElementFormGroup',
  props: {
    label: {
      type: String,
      required: false,
      default: 'Form Group Label'
    },
    labelIcon: {
      type: String,
      required: false,
      default: null
    }
  },
  components: {
    BaseIcon
  }
}
</script>

<style lang="scss">
  .form-group{
    margin-bottom: 1.5rem;

    label{
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .icon {
        flex: 0 1 auto;
        margin-right: 1rem;
      }

      span{
        flex: 1 1 auto;
      }

      a {
        flex: 0 1 auto;
        align-self: flex-end;
      }
    }
  }
</style>
